import { CountClient } from "@formant/core/client/CountClient";
import { IActiveDevicesQuery } from "@formant/core/model/IActiveDevicesQuery";
import { Uuid } from "@formant/core/model/Uuid";

import { IAuthStore } from "./IAuthStore";
import { StoreCache } from "./StoreCache";

export class CountStore {
    private activeDevicesCache = new StoreCache<IActiveDevicesQuery, Uuid[]>();

    constructor(
        private countClient: CountClient,
        private authStore: IAuthStore,
    ) {}

    public activeDevices(query: IActiveDevicesQuery): Uuid[] | undefined {
        return this.activeDevicesCache.get(query, async () =>
            this.countClient.activeDevices(await this.authStore.token(), query),
        );
    }
}
